import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { FormGrid } from "@/components/ui/form-grid";
import { Heading } from "@/components/ui/heading";
import { HStack } from "@/components/ui/h-stack";
import { Surface } from "@/components/ui/surface";
import { Icon } from "@/components/ui/icons";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/v-stack";

interface AccountMenuItem {
  href: string;
  label: string;
  description: string;
  icon: typeof Icon.User;
}

function AccountPage() {
  const navigate = useNavigate();
  const { t: tNav } = useTranslation("nav");
  const { t: tAccount } = useTranslation("account");
  const { t: tSettings } = useTranslation("settings");

  const menuItems: AccountMenuItem[] = [
    {
      href: "/account/profile",
      label: tNav("profile"),
      description: tAccount("profileDescription"),
      icon: Icon.User,
    },
    {
      href: "/account/notifications",
      label: tSettings("notifications"),
      description: tAccount("notificationsDescription"),
      icon: Icon.Bell,
    },
    {
      href: "/account/security",
      label: tSettings("security"),
      description: tAccount("securityDescription"),
      icon: Icon.CheckBadge,
    },
    {
      href: "/account/preferences",
      label: tSettings("preferences"),
      description: tAccount("preferencesDescription"),
      icon: Icon.Sun,
    },
  ];

  return (
    <VStack gap="xl" data-testid="account-page">
      <FormGrid>
        {menuItems.map((item) => {
          const ItemIcon = item.icon;
          return (
            <Card
              key={item.href}
              padding="none"
              className="hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => void navigate({ to: item.href })}
              data-testid={`account-menu-${item.href.split("/").pop()}`}
            >
              <HStack align="start" gap="xl" className="p-6">
                <Surface
                  bg="primary-container"
                  rounded="lg"
                  className="flex flex-shrink-0 w-12 h-12 items-center justify-center"
                >
                  <ItemIcon className="text-[color:var(--primary)]" size="lg" />
                </Surface>
                <VStack fill truncate gap="none">
                  <Heading size="sm" className="mb-1">
                    {item.label}
                  </Heading>
                  <Text color="muted">{item.description}</Text>
                </VStack>
                <Icon.ChevronRight color="muted" className="flex-shrink-0" />
              </HStack>
            </Card>
          );
        })}
      </FormGrid>
    </VStack>
  );
}

export const Route = createFileRoute("/_app/account/")({
  component: AccountPage,
});
